/**
 * Rascunho da caixa de escrever, por conversa: sair da conversa (ESC, voltar,
 * abrir outra) não apaga o que estava escrito. Fica só na memória da aba e é
 * apagado ao sair da conta, para o próximo usuário do computador não ver.
 */
import { aoLimparDadosDoTenant } from "../../../utils/tenantStorage";

const rascunhos = new Map();

aoLimparDadosDoTenant(() => rascunhos.clear());

export function lerRascunho(conversaId) {
  return rascunhos.get(String(conversaId)) || "";
}

export function guardarRascunho(conversaId, texto) {
  if (texto) rascunhos.set(String(conversaId), texto);
  else rascunhos.delete(String(conversaId));
}
